// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';

class LibraryForm {
  @IsOptional()
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

export class ExportSymbolForm {
  @ValidateNested()
  library: LibraryForm;
}
